export default __webpack_public_path__ + "static/media/absence.87356aa4.svg";